import React from "react";

import { useAdvancedTabsSingleStore } from "../../../../../stores/use-advanced-tabs-single-store";
import { AdvancedTabsSingleEditorContainer } from "./styles";
import AdvancedTabs from "../advanced-tabs/AdvancedTabs";

const AdvancedTabsSingleEditor = () => {
  const data = useAdvancedTabsSingleStore((state) => state.data);

  return (
    <AdvancedTabsSingleEditorContainer>
      <AdvancedTabs data={data} />
    </AdvancedTabsSingleEditorContainer>
  );
};

export default AdvancedTabsSingleEditor;
